/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RewardsRouteImport } from './routes/rewards'
import { Route as RewardRouteImport } from './routes/reward'
import { Route as CountrySelectRouteImport } from './routes/countrySelect'
import { Route as Char42RouteImport } from './routes/*'
import { Route as ServiceRouteImport } from './routes/$service'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GiveawaysIndexRouteImport } from './routes/giveaways/index'
import { Route as ServiceIndexRouteImport } from './routes/$service/index'
import { Route as OperatoorGiveawaysRouteImport } from './routes/operatoor/giveaways'
import { Route as OperatoorCreateRouteImport } from './routes/operatoor/create'
import { Route as GiveawaysHistoryRouteImport } from './routes/giveaways/history'
import { Route as GiveawaysProgramIdRouteImport } from './routes/giveaways/$programId'
import { Route as ServiceAdRouteImport } from './routes/$service/ad'
import { Route as GiveawaysProgramIdIndexRouteImport } from './routes/giveaways/$programId/index'
import { Route as ServiceProductSKUIndexRouteImport } from './routes/$service/$productSKU/index'
import { Route as GiveawaysProgramIdAdRouteImport } from './routes/giveaways/$programId/ad'
import { Route as ServiceProductSKUAdRouteImport } from './routes/$service/$productSKU/ad'

const RewardsRoute = RewardsRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => rootRouteImport,
} as any)
const RewardRoute = RewardRouteImport.update({
  id: '/reward',
  path: '/reward',
  getParentRoute: () => rootRouteImport,
} as any)
const CountrySelectRoute = CountrySelectRouteImport.update({
  id: '/countrySelect',
  path: '/countrySelect',
  getParentRoute: () => rootRouteImport,
} as any)
const Char42Route = Char42RouteImport.update({
  id: '/*',
  path: '/*',
  getParentRoute: () => rootRouteImport,
} as any)
const ServiceRoute = ServiceRouteImport.update({
  id: '/$service',
  path: '/$service',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GiveawaysIndexRoute = GiveawaysIndexRouteImport.update({
  id: '/giveaways/',
  path: '/giveaways/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServiceIndexRoute = ServiceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ServiceRoute,
} as any)
const OperatoorGiveawaysRoute = OperatoorGiveawaysRouteImport.update({
  id: '/operatoor/giveaways',
  path: '/operatoor/giveaways',
  getParentRoute: () => rootRouteImport,
} as any)
const OperatoorCreateRoute = OperatoorCreateRouteImport.update({
  id: '/operatoor/create',
  path: '/operatoor/create',
  getParentRoute: () => rootRouteImport,
} as any)
const GiveawaysHistoryRoute = GiveawaysHistoryRouteImport.update({
  id: '/giveaways/history',
  path: '/giveaways/history',
  getParentRoute: () => rootRouteImport,
} as any)
const GiveawaysProgramIdRoute = GiveawaysProgramIdRouteImport.update({
  id: '/giveaways/$programId',
  path: '/giveaways/$programId',
  getParentRoute: () => rootRouteImport,
} as any)
const ServiceAdRoute = ServiceAdRouteImport.update({
  id: '/ad',
  path: '/ad',
  getParentRoute: () => ServiceRoute,
} as any)
const GiveawaysProgramIdIndexRoute = GiveawaysProgramIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GiveawaysProgramIdRoute,
} as any)
const ServiceProductSKUIndexRoute = ServiceProductSKUIndexRouteImport.update({
  id: '/$productSKU/',
  path: '/$productSKU/',
  getParentRoute: () => ServiceRoute,
} as any)
const GiveawaysProgramIdAdRoute = GiveawaysProgramIdAdRouteImport.update({
  id: '/ad',
  path: '/ad',
  getParentRoute: () => GiveawaysProgramIdRoute,
} as any)
const ServiceProductSKUAdRoute = ServiceProductSKUAdRouteImport.update({
  id: '/$productSKU/ad',
  path: '/$productSKU/ad',
  getParentRoute: () => ServiceRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$service': typeof ServiceRouteWithChildren
  '/*': typeof Char42Route
  '/countrySelect': typeof CountrySelectRoute
  '/reward': typeof RewardRoute
  '/rewards': typeof RewardsRoute
  '/$service/ad': typeof ServiceAdRoute
  '/giveaways/$programId': typeof GiveawaysProgramIdRouteWithChildren
  '/giveaways/history': typeof GiveawaysHistoryRoute
  '/operatoor/create': typeof OperatoorCreateRoute
  '/operatoor/giveaways': typeof OperatoorGiveawaysRoute
  '/$service/': typeof ServiceIndexRoute
  '/giveaways': typeof GiveawaysIndexRoute
  '/$service/$productSKU/ad': typeof ServiceProductSKUAdRoute
  '/giveaways/$programId/ad': typeof GiveawaysProgramIdAdRoute
  '/$service/$productSKU': typeof ServiceProductSKUIndexRoute
  '/giveaways/$programId/': typeof GiveawaysProgramIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/*': typeof Char42Route
  '/countrySelect': typeof CountrySelectRoute
  '/reward': typeof RewardRoute
  '/rewards': typeof RewardsRoute
  '/$service/ad': typeof ServiceAdRoute
  '/giveaways/history': typeof GiveawaysHistoryRoute
  '/operatoor/create': typeof OperatoorCreateRoute
  '/operatoor/giveaways': typeof OperatoorGiveawaysRoute
  '/$service': typeof ServiceIndexRoute
  '/giveaways': typeof GiveawaysIndexRoute
  '/$service/$productSKU/ad': typeof ServiceProductSKUAdRoute
  '/giveaways/$programId/ad': typeof GiveawaysProgramIdAdRoute
  '/$service/$productSKU': typeof ServiceProductSKUIndexRoute
  '/giveaways/$programId': typeof GiveawaysProgramIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$service': typeof ServiceRouteWithChildren
  '/*': typeof Char42Route
  '/countrySelect': typeof CountrySelectRoute
  '/reward': typeof RewardRoute
  '/rewards': typeof RewardsRoute
  '/$service/ad': typeof ServiceAdRoute
  '/giveaways/$programId': typeof GiveawaysProgramIdRouteWithChildren
  '/giveaways/history': typeof GiveawaysHistoryRoute
  '/operatoor/create': typeof OperatoorCreateRoute
  '/operatoor/giveaways': typeof OperatoorGiveawaysRoute
  '/$service/': typeof ServiceIndexRoute
  '/giveaways/': typeof GiveawaysIndexRoute
  '/$service/$productSKU/ad': typeof ServiceProductSKUAdRoute
  '/giveaways/$programId/ad': typeof GiveawaysProgramIdAdRoute
  '/$service/$productSKU/': typeof ServiceProductSKUIndexRoute
  '/giveaways/$programId/': typeof GiveawaysProgramIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$service'
    | '/*'
    | '/countrySelect'
    | '/reward'
    | '/rewards'
    | '/$service/ad'
    | '/giveaways/$programId'
    | '/giveaways/history'
    | '/operatoor/create'
    | '/operatoor/giveaways'
    | '/$service/'
    | '/giveaways'
    | '/$service/$productSKU/ad'
    | '/giveaways/$programId/ad'
    | '/$service/$productSKU'
    | '/giveaways/$programId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/*'
    | '/countrySelect'
    | '/reward'
    | '/rewards'
    | '/$service/ad'
    | '/giveaways/history'
    | '/operatoor/create'
    | '/operatoor/giveaways'
    | '/$service'
    | '/giveaways'
    | '/$service/$productSKU/ad'
    | '/giveaways/$programId/ad'
    | '/$service/$productSKU'
    | '/giveaways/$programId'
  id:
    | '__root__'
    | '/'
    | '/$service'
    | '/*'
    | '/countrySelect'
    | '/reward'
    | '/rewards'
    | '/$service/ad'
    | '/giveaways/$programId'
    | '/giveaways/history'
    | '/operatoor/create'
    | '/operatoor/giveaways'
    | '/$service/'
    | '/giveaways/'
    | '/$service/$productSKU/ad'
    | '/giveaways/$programId/ad'
    | '/$service/$productSKU/'
    | '/giveaways/$programId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ServiceRoute: typeof ServiceRouteWithChildren
  Char42Route: typeof Char42Route
  CountrySelectRoute: typeof CountrySelectRoute
  RewardRoute: typeof RewardRoute
  RewardsRoute: typeof RewardsRoute
  GiveawaysProgramIdRoute: typeof GiveawaysProgramIdRouteWithChildren
  GiveawaysHistoryRoute: typeof GiveawaysHistoryRoute
  OperatoorCreateRoute: typeof OperatoorCreateRoute
  OperatoorGiveawaysRoute: typeof OperatoorGiveawaysRoute
  GiveawaysIndexRoute: typeof GiveawaysIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/rewards': {
      id: '/rewards'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof RewardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reward': {
      id: '/reward'
      path: '/reward'
      fullPath: '/reward'
      preLoaderRoute: typeof RewardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/countrySelect': {
      id: '/countrySelect'
      path: '/countrySelect'
      fullPath: '/countrySelect'
      preLoaderRoute: typeof CountrySelectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/*': {
      id: '/*'
      path: '/*'
      fullPath: '/*'
      preLoaderRoute: typeof Char42RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$service': {
      id: '/$service'
      path: '/$service'
      fullPath: '/$service'
      preLoaderRoute: typeof ServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/giveaways/': {
      id: '/giveaways/'
      path: '/giveaways'
      fullPath: '/giveaways'
      preLoaderRoute: typeof GiveawaysIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$service/': {
      id: '/$service/'
      path: '/'
      fullPath: '/$service/'
      preLoaderRoute: typeof ServiceIndexRouteImport
      parentRoute: typeof ServiceRoute
    }
    '/operatoor/giveaways': {
      id: '/operatoor/giveaways'
      path: '/operatoor/giveaways'
      fullPath: '/operatoor/giveaways'
      preLoaderRoute: typeof OperatoorGiveawaysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operatoor/create': {
      id: '/operatoor/create'
      path: '/operatoor/create'
      fullPath: '/operatoor/create'
      preLoaderRoute: typeof OperatoorCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/giveaways/history': {
      id: '/giveaways/history'
      path: '/giveaways/history'
      fullPath: '/giveaways/history'
      preLoaderRoute: typeof GiveawaysHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/giveaways/$programId': {
      id: '/giveaways/$programId'
      path: '/giveaways/$programId'
      fullPath: '/giveaways/$programId'
      preLoaderRoute: typeof GiveawaysProgramIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$service/ad': {
      id: '/$service/ad'
      path: '/ad'
      fullPath: '/$service/ad'
      preLoaderRoute: typeof ServiceAdRouteImport
      parentRoute: typeof ServiceRoute
    }
    '/giveaways/$programId/': {
      id: '/giveaways/$programId/'
      path: '/'
      fullPath: '/giveaways/$programId/'
      preLoaderRoute: typeof GiveawaysProgramIdIndexRouteImport
      parentRoute: typeof GiveawaysProgramIdRoute
    }
    '/$service/$productSKU/': {
      id: '/$service/$productSKU/'
      path: '/$productSKU'
      fullPath: '/$service/$productSKU'
      preLoaderRoute: typeof ServiceProductSKUIndexRouteImport
      parentRoute: typeof ServiceRoute
    }
    '/giveaways/$programId/ad': {
      id: '/giveaways/$programId/ad'
      path: '/ad'
      fullPath: '/giveaways/$programId/ad'
      preLoaderRoute: typeof GiveawaysProgramIdAdRouteImport
      parentRoute: typeof GiveawaysProgramIdRoute
    }
    '/$service/$productSKU/ad': {
      id: '/$service/$productSKU/ad'
      path: '/$productSKU/ad'
      fullPath: '/$service/$productSKU/ad'
      preLoaderRoute: typeof ServiceProductSKUAdRouteImport
      parentRoute: typeof ServiceRoute
    }
  }
}

interface ServiceRouteChildren {
  ServiceAdRoute: typeof ServiceAdRoute
  ServiceIndexRoute: typeof ServiceIndexRoute
  ServiceProductSKUAdRoute: typeof ServiceProductSKUAdRoute
  ServiceProductSKUIndexRoute: typeof ServiceProductSKUIndexRoute
}

const ServiceRouteChildren: ServiceRouteChildren = {
  ServiceAdRoute: ServiceAdRoute,
  ServiceIndexRoute: ServiceIndexRoute,
  ServiceProductSKUAdRoute: ServiceProductSKUAdRoute,
  ServiceProductSKUIndexRoute: ServiceProductSKUIndexRoute,
}

const ServiceRouteWithChildren =
  ServiceRoute._addFileChildren(ServiceRouteChildren)

interface GiveawaysProgramIdRouteChildren {
  GiveawaysProgramIdAdRoute: typeof GiveawaysProgramIdAdRoute
  GiveawaysProgramIdIndexRoute: typeof GiveawaysProgramIdIndexRoute
}

const GiveawaysProgramIdRouteChildren: GiveawaysProgramIdRouteChildren = {
  GiveawaysProgramIdAdRoute: GiveawaysProgramIdAdRoute,
  GiveawaysProgramIdIndexRoute: GiveawaysProgramIdIndexRoute,
}

const GiveawaysProgramIdRouteWithChildren =
  GiveawaysProgramIdRoute._addFileChildren(GiveawaysProgramIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ServiceRoute: ServiceRouteWithChildren,
  Char42Route: Char42Route,
  CountrySelectRoute: CountrySelectRoute,
  RewardRoute: RewardRoute,
  RewardsRoute: RewardsRoute,
  GiveawaysProgramIdRoute: GiveawaysProgramIdRouteWithChildren,
  GiveawaysHistoryRoute: GiveawaysHistoryRoute,
  OperatoorCreateRoute: OperatoorCreateRoute,
  OperatoorGiveawaysRoute: OperatoorGiveawaysRoute,
  GiveawaysIndexRoute: GiveawaysIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
